import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { 
  MAT_DIALOG_DATA, 
  MatDialogRef, 
  MatDialogTitle, 
  MatDialogContent, 
  MatDialogActions 
} from '@angular/material/dialog';

export interface DialogSiNoData {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
}

@Component({
  selector: 'app-dialog-si-no',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions
  ],
  templateUrl: './dialog-si-no.component.html',
  styleUrl: './dialog-si-no.component.scss'
})
export class DialogSiNoComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogSiNoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogSiNoData
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}